export let ToolStack =[
    'photoshop',
    'illustrator',
    'figma',
    'vs code',
    'android studio'
]
export let TechStack = [
    'html',
    'css',
    'js',
    'flutter',
    'android',
    'react',
    'java',
    'bootstrap',
    'tailwind'
]